import classes from './skeleton.module.css';

type SkeletonProps = {
  width?: string;
  height?: string;
  className?: string;
};

export const Skeleton = ({ width = '100%', height = '20px', className }: SkeletonProps) => {
  return (
    <div
      className={`${classes.skeleton} ${className || ''}`}
      style={{ width, height }}
    />
  );
};
